import Motorcycle from '@/models/Motorcycle'
import User, { hasRole, Role } from '@/models/User'

export default class MotorcyclePolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, motorcycle: Motorcycle) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === motorcycle.entry.catalog.company.id
			case Role.AUDITOR:
				return user.auditor?.id === motorcycle.entry.catalog.auditor?.id
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, motorcycle: Motorcycle) {
		return hasRole(user, Role.USER) && user.company?.id === motorcycle.entry.catalog.company.id
	}

	restore(user: User, motorcycle: Motorcycle) {
		return hasRole(user, Role.USER) && user.company?.id === motorcycle.entry.catalog.company.id
	}

	delete(user: User, motorcycle: Motorcycle) {
		return hasRole(user, Role.USER) && user.company?.id === motorcycle.entry.catalog.company.id
	}

	forceDelete(_user: User, _motorcycle: Motorcycle) {
		return false
	}
}
